import { FC, useContext } from 'react';
import { DotsItem } from 'react-alice-carousel';
import Carousel from '@components/carousel';
import ReviewCard from '@components/comments/review';
import Info from '@components/footer/Info';
import { userReview } from '@components/footer/utils';
import { GlobalContext } from '@context/GlobalContext';
import { tw } from '@utils/tailwind-utils';
import clsx from 'clsx';
import { Trans, useTranslation } from 'next-i18next';
import { City } from 'src/api/types/cities';

interface FooterProps {
  cities: City[];
  showReview?: boolean;
  promoClassName?: string;
  enabledNewsLetter?: boolean;
}

const Footer: FC<FooterProps> = ({ cities, showReview, promoClassName, enabledNewsLetter }) => {
  const { t } = useTranslation(['landing', 'footer']);
  const {
    responsiveState: { isTablet }
  } = useContext(GlobalContext);

  return (
    <div
      className="flex w-full items-center justify-center  bg-cover bg-no-repeat pb-10 bg-blend-luminosity"
      style={{
        backgroundImage: 'url(/images/Background_Foofter.svg)'
      }}
    >
      <div className="w-full px-3 pt-16 lg:w-[1100px]">
        {showReview && (
          <div
            className={tw('flex w-full justify-center', {
              hidden: !showReview
            })}
          >
            <div className="text-center font-bree-serif font-normal text-white ">
              <Trans
                t={t}
                i18nKey="landing.footer.title"
                components={{
                  text1: <h2 className="text-[34px] leading-6 lg:text-[40px]" />,
                  text2: <h3 className="text-[16px] leading-[45px] lg:pt-1 lg:text-[18px]" />
                }}
              />
            </div>
          </div>
        )}
        {showReview && (
          <div
            className={tw('reviews px-10 py-10 lg:px-0', {
              hidden: !showReview
            })}
          >
            <Carousel
              className="user-comments"
              showDots
              dotsItems={(dotItem: DotsItem) => (
                <div
                  className={clsx('ml-4 h-[14px] w-[14px] rounded-full border-[2px] border-white', {
                    'bg-white': dotItem.isActive
                  })}
                />
              )}
              items={userReview.map(({ name, avatarImage, review }, index) => (
                <div
                  key={`${name}-${index}`}
                  onDragStart={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                  }}
                >
                  <ReviewCard name={name} avatarImage={avatarImage} review={t(review)} />
                </div>
              ))}
              responsiveData={{
                0: { items: 1 },
                1020: { items: 2 },
                1150: { items: 3 }
              }}
            />
          </div>
        )}
        <Info cities={cities} isTablet={isTablet} classNames={promoClassName} enabledNewsLetter={enabledNewsLetter} />
      </div>
    </div>
  );
};

export default Footer;
